import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, Close } from '@mui/icons-material';
import logo from '../media/logo.png';

const Header = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <header className="bg-background text-text py-4 px-6 shadow-md">
            <div className="container mx-auto flex justify-between items-center">
                <div className="flex items-center">
                    <Link to="/" aria-label="Home" className="flex items-center">
                        <img src={logo} alt="Scammer List Logo" className="h-10 mr-3" />
                        <h1 className="text-2xl font-bold text-primary">Scammer List</h1>
                    </Link>
                </div>

                <nav className="hidden md:flex space-x-6">
                    <Link to="/lookup" className="text-accent hover:text-primary transition duration-300">Scammer Lookup</Link>
                    <a href="https://discord.com/invite/scammerlist" className="text-accent hover:text-primary transition duration-300">Join Our Discord</a>
                    <a href="https://discord.com/oauth2/authorize?client_id=1193165627704217710" className="text-accent hover:text-primary transition duration-300">Invite Our Bot</a>
                </nav>

                <div className="md:hidden flex items-center">
                    <button 
                        onClick={toggleMobileMenu}
                        aria-label="Toggle mobile menu"
                        className="text-text hover:text-primary transition duration-300 focus:outline-none"
                    >
                        {isMobileMenuOpen ? <Close fontSize="large" /> : <Menu fontSize="large" />}
                    </button>
                </div>
            </div>

            {isMobileMenuOpen && (
                <nav className="md:hidden bg-background text-text py-4">
                    <ul className="flex flex-col items-center space-y-4">
                        <li>
                            <Link to="/lookup" className="text-accent hover:text-primary transition duration-300" onClick={toggleMobileMenu}>Scammer Lookup</Link>
                        </li>
                        <li>
                            <a href="https://discord.com/invite/scammerlist" className="text-accent hover:text-primary transition duration-300" onClick={toggleMobileMenu}>Join Our Discord</a>
                        </li>
                        <li>
                            <a href="https://discord.com/oauth2/authorize?client_id=1193165627704217710" className="text-accent hover:text-primary transition duration-300" onClick={toggleMobileMenu}>Invite Our Bot</a>
                        </li>
                    </ul>
                </nav>
            )}
        </header>
    );
};

export default Header;
